import React, { useEffect, useState, useRef } from 'react';
import { Parallax } from 'react-scroll-parallax';
import { Link } from 'gatsby';
import apiClient from '../utils/apiClient';
import Layout from '../components/Layout';
import SEO from '../components/SEO';

const Career = (props) => {
  const [jobs, setJobs] = useState([]);

  const checkMarkSVG = useRef(
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 18 18"
      style={{ enableBackground: 'new 0 0 18 18' }}>
      <g>
        <path
          style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            fill: '#2758C8',
          }}
          d="M15.4,2.6c-3.5-3.5-9.2-3.5-12.7,0c-3.5,3.5-3.5,9.2,0,12.7c3.5,3.5,9.2,3.5,12.7,0S18.9,6.2,15.4,2.6z
M13.9,7.6l-4.8,4.8c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.5-0.1-0.7-0.3L5,9.7c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l2,2l4.1-4.1
c0.4-0.4,1-0.4,1.4,0C14.3,6.6,14.3,7.2,13.9,7.6z"
        />
      </g>
    </svg>,
  );

  useEffect(() => {
    let timeOut = null;

    const careerPerson = document.getElementsByClassName('hero-thumb-single');

    let previousCareerPerson = null;

    function repeatOften() {
      if (previousCareerPerson) previousCareerPerson.classList.toggle('active');
      const random = Math.floor(Math.random() * (careerPerson.length - 1)) + 0;
      const randomPerson = careerPerson[random];
      randomPerson.classList.toggle('active');
      previousCareerPerson = randomPerson;
      timeOut = setTimeout(repeatOften, 3000);
    }

    repeatOften();

    return () => {
      if (timeOut) {
        clearTimeout(timeOut);
      }
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await apiClient.get('/jobs');

        setJobs(Array.isArray(data) ? data : []);
      } catch (e) {
        /* do nothing */
      }
    })();
  }, []);

  useEffect(() => {
    const links = document.querySelectorAll('.smooth-scroll');
    for (const link of links) {
      link.addEventListener('click', clickHandler);
    }

    function clickHandler(e) {
      e.preventDefault();
      const href = this.getAttribute('href');
      const offsetTop = document.querySelector(href).offsetTop;

      scroll({
        top: offsetTop,
        behavior: 'smooth',
      });
    }
  }, []);

  return (
    <Layout {...props}>
      <SEO
        title="Improving the way construction teams work | Careers at Powerplay"
        description="Want to be a part of the team that is bringing software development to construction management? Explore job opportunities at Powerplay on their careers page."
      />

      <section className="inner-hero-main">
        <div className="container">
          <div className="inner-hero-content career-hero-main">
            <h5>CAREERS</h5>
            <h1>Explore opportunities at Powerplay</h1>
            <p style={{ fontSize: 20 }}>
              Join a passionate, pan-India team optimising construction projects
              and their execution
            </p>
            <Link className="button smooth-scroll" href="#opportunities">
              Explore Opportunities
            </Link>
          </div>
        </div>

        <div className="container">
          <div className="career-hero-graphic hidden-mobile">
            <svg
              x="0px"
              y="0px"
              viewBox="0 0 1207 300"
              style={{ enableBackground: 'new 0 0 1207 300' }}>
              <g transform="translate(-103.000000, -325.000000)">
                <path
                  d="M104,332.5c71.2,25.7,118.2,96.7,141,212.9c34.2,174.3,158.5-63.7,293.2-47.6
			c134.8,16,134.8,45.1,220,95.2c85.2,50.1,283,56.2,365-109.9c54.7-110.7,117.9-162.9,189.7-156.6"
                />
              </g>
            </svg>

            <div className="career-hero-thumbs">
              <div className="hero-thumb-single">
                <img src="/img/career-1.png" alt="career" />
                <p>Yash, Product designer</p>
              </div>
              <div className="hero-thumb-single">
                <img src="/img/career-2.png" alt="career" />
                <p className="left-txt">Prachi, Marketing Manager</p>
              </div>
              <div className="hero-thumb-single">
                <img src="/img/career-3.png" alt="career" />
                <p>Rohan, Frontend Dev</p>
              </div>
              <div className="hero-thumb-single">
                <img src="/img/career-4.png" alt="career" />
                <p className="left-txt">Saurabh, Growth PM</p>
              </div>
              <div className="hero-thumb-single">
                <img src="/img/career-5.png" alt="career" />
                <p>Purvi, Human Resources</p>
              </div>
              <div className="hero-thumb-single">
                <img src="/img/career-6.png" alt="career" />
                <p className="left-txt">Aayush, Customer Success</p>
              </div>
            </div>
          </div>
          <div className="visible-mobile" style={{ padding: '20px 0 60px' }}>
            <img src="/img/career-graphic-mobile.png" alt="career" />
          </div>
        </div>
      </section>

      <section className="pad100 bg-lightblue career-quote">
        <div className="container">
          <div className="flex-row">
            <div className="col col-4">
              <h2 className="heading">
                Software innovation to power infrastructure development
              </h2>
            </div>
            <div className="col col-6 offset-2">
              <p className="big-txt">
                We&apos;re keen to make the process of constructing everything
                from the tallest buildings to the longest roads faster and more
                transparent.
              </p>

              <p className="big-txt">
                Our goal is to digitise Indian construction to ensure that
                owners don&apos;t lose precious time or money to wrong estimates
                or delays.
              </p>
              <p className="big-txt">
                That&apos;s why, we work with people who are committed to making
                an impact, a real one.
              </p>
            </div>
          </div>
        </div>

        <Parallax x={[10, -17]} tagOuter="div">
          <div className="career-parallax-img">
            <img src="/img/career-office-1.png" alt="office" width="643px" />
            <img src="/img/career-office-2.png" alt="office" width="430px" />
            <img src="/img/career-office-3.png" alt="office" width="386px" />
            <img src="/img/career-office-4.png" alt="office" width="611px" />
          </div>
        </Parallax>
      </section>

      <section className="pad100">
        <div className="container">
          <h2 className="heading text-center" style={{ margin: '0 auto 20px' }}>
            What Keeps us Going
          </h2>
          <p
            className="big-txt text-center"
            style={{ maxWidth: '575px', margin: '0 auto 40px' }}>
            These are the values that guide and motivate us at Powerplay,
            helping us make each day better than the last.
          </p>
          <div className="thrive-main">
            <div className="flex-row justify-content-center">
              <div className="col col-3">
                <div className="single-thrive-block text-center">
                  <img src="/img/thrive-1.svg" alt="icon" />
                  <h4>Constant Growth</h4>
                  <p>We measure growth in weeks, so consistency is key.</p>
                </div>
              </div>
              <div className="col col-3">
                <div className="single-thrive-block text-center">
                  <img src="/img/raise-bar.svg" alt="icon" />
                  <h4>Raise The Bar</h4>
                  <p>
                    Along with trust and integrity, you’ll need drive and
                    intelligence.
                  </p>
                </div>
              </div>
              <div className="col col-3">
                <div className="single-thrive-block text-center">
                  <img src="/img/values-icon.svg" alt="icon" />
                  <h4>Live in the future to build it</h4>
                  <p>
                    Experiment and learn — the cost of inaction is higher than
                    the cost of failure.
                  </p>
                </div>
              </div>
              <div className="col col-3">
                <div className="single-thrive-block text-center">
                  <img src="/img/promise-icon.svg" alt="icon" />
                  <h4>Dig a deep well, not a shallow pool</h4>
                  <p>
                    Prioritize making products users really love, not just like.
                  </p>
                </div>
              </div>
              <div className="col col-3">
                <div className="single-thrive-block text-center">
                  <img src="/img/focus.svg" alt="icon" />
                  <h4>Have a Laser-Sharp Focus</h4>
                  <p>Focus on one task at a time and do it perfectly.</p>
                </div>
              </div>
              <div className="col col-3">
                <div className="single-thrive-block text-center">
                  <img src="/img/thrive-2.svg" alt="icon" />
                  <h4>Delegate to machines</h4>
                  <p>
                    Do highly technical or creative work, automate the rest.
                  </p>
                </div>
              </div>
              <div className="col col-3">
                <div className="single-thrive-block text-center">
                  <img src="/img/feedback.svg" alt="icon" />
                  <h4>Give Clear Feedback</h4>
                  <p>
                    Be a part of the team, encourage others to grow with honest
                    feedback.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <img
          src="/img/career-big-image.jpg"
          style={{ width: '100%' }}
          alt="career"
        />
      </section>

      <section className="pad100">
        <div className="container">
          <h2 className="heading" style={{ marginBottom: '40px' }}>
            Why you’ll love it at Powerplay
          </h2>
          <div className="powerplay-benifit-main">
            <div className="flex-row">
              <div className="col-4 col">
                <div className="powerplay-benifit">
                  {checkMarkSVG.current}
                  <div>
                    <h4>Personal growth</h4>
                    <p style={{ maxWidth: 303 }}>
                      You’ll get several opportunities to explore your ideas and
                      bring them to life at Powerplay
                    </p>
                  </div>
                </div>
              </div>
              <div className="col col-4">
                <div className="powerplay-benifit">
                  {checkMarkSVG.current}
                  <div>
                    <h4>Work with the best</h4>
                    <p>
                      At Powerplay, the bar is high. You’ll be constantly
                      challenged and motivated to work with some of the best
                      people in the industry.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col col-4">
                <div className="powerplay-benifit">
                  {checkMarkSVG.current}
                  <div>
                    <h4>Make a real impact</h4>
                    <p>
                      We’re backed by global investors who help us digitise the
                      construction process to save time, effort, and money.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pad100 bg-lightblue">
        <div className="container">
          <h2 className="heading text-center" style={{ marginBottom: '55px' }}>
            We&apos;ve Got Awesome Perks!
          </h2>
          <div className="perks-main">
            <div className="flex-row">
              <div className="col col-3">
                <div className="perk-single text-center">
                  <img src="/img/salary.svg" alt="salary" width="36px" />
                  <p>
                    Competitive salary +
                    <br />
                    ESOPs
                  </p>
                </div>
              </div>
              <div className="col col-3">
                <div className="perk-single text-center">
                  <img src="/img/briefcase.svg" alt="briefcase" width="40px" />
                  <p>Flexible working hours &amp; work-life balance</p>
                </div>
              </div>
              <div className="col col-3">
                <div className="perk-single text-center">
                  <img src="/img/pharmacy.svg" alt="pharmacy" width="40px" />
                  <p>Health insurance for you and your dependents</p>
                </div>
              </div>
              <div className="col col-3">
                <div className="perk-single text-center">
                  <img
                    src="/img/coffee-mug.svg"
                    alt="coffee-mug"
                    width="40px"
                  />
                  <p>Enjoy amazing food, all on the house</p>
                </div>
              </div>
              <div className="col col-3">
                <div className="perk-single text-center">
                  <img src="/img/computer.svg" alt="computer" width="40px" />
                  <p>Choose your own hardware and work station</p>
                </div>
              </div>
              <div className="col col-3">
                <div className="perk-single text-center">
                  <img src="/img/rocket.svg" alt="rocket" width="40px" />
                  <p>Build for the next billion internet users</p>
                </div>
              </div>
              <div className="col col-3">
                <div className="perk-single text-center">
                  <img src="/img/garland.svg" alt="garland" width="40px" />
                  <p>De-stress and unwind with cool office parties</p>
                </div>
              </div>
              <div className="col col-3">
                <div className="perk-single text-center">
                  <img
                    src="/img/motivation.svg"
                    alt="motivation"
                    width="40px"
                  />
                  <p>Health and wellness programme</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pad100" id="opportunities">
        <div className="container">
          <h2 className="heading text-center">Open Positions</h2>
          <p
            className="big-txt text-center"
            style={{ maxWidth: '830px', margin: '0 auto 30px' }}>
            Looking to shine in a new role or take your career to the next
            level? Check out our open positions below. No opportunity that
            catches your fancy? Email us at{' '}
            <a
              href="mailto:talent@getpowerplay.in"
              style={{ color: '#2258d4' }}>
              talent@getpowerplay.in
            </a>{' '}
            with your CV, and let’s talk
          </p>

          <div className="open-position-main">
            <div className="flex-row">
              <div className="col col-10 offset-1">
                {jobs.map((job) => (
                  <a
                    key={job.id}
                    href={job?.applicant_apply_link}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="single-position">
                    <div className="position-title">
                      <h3>{job?.title}</h3>
                      <p>
                        {job?.department?.name} |{' '}
                        <span style={{ textTransform: 'capitalize' }}>
                          {job?.type.replace('_', '')}
                        </span>
                        &nbsp;·&nbsp;{job?.branch?.city}
                      </p>
                    </div>
                    <div className="easy-apply">
                      <span className="button">Apply Now</span>
                      <a href="#!" className="listing-link">
                        <span>See more</span>
                        <svg
                          x="0px"
                          y="0px"
                          viewBox="0 0 24 21"
                          style={{ enableBackground: 'new 0 0 24 21' }}>
                          <path
                            style={{ fill: '#2758C8' }}
                            d="M14.7,0.3c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1.1,0,1.5L21,9.4H1c-0.6,0-1,0.5-1,1.1c0,0.6,0.4,1.1,1,1.1h19.9
                  l-7.6,7.6c-0.4,0.4-0.4,1.1,0,1.5c0.2,0.2,0.5,0.3,0.7,0.3c0.2,0,0.5-0.1,0.7-0.3l8.7-8.7c0.4-0.4,0.6-0.9,0.6-1.5
                  c0-0.6-0.2-1.1-0.6-1.5L14.7,0.3z"
                          />
                        </svg>
                      </a>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Career;
